import React from 'react';

const TimeframeRow = ({ dates, width }) => {
  const isToday = (date) => {
    const today = new Date();
    return new Date(date).toDateString() === today.toDateString();
  };
  return (
    <div className="timeframe-row" style={{ width: `${width}px` }}>
      {dates.map((date, index) => (
        <div className={`timeframe-date ${isToday(date) ? 'timeframe-today' : ''}`} key={index}>
          {new Date(date).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
        </div>
      ))}
    </div>
  );
};

export default TimeframeRow;
